import { fetcher } from '@commenda/utils';

export const updateBillingQuoteLineQty = async (
  quoteId: string,
  lineId: string,
  qty: number,
  expectedEditVersion?: number
) => {
  const response = await fetcher(
    `commenda-billing/quotes/${quoteId}/lines/${lineId}`,
    {
      method: 'PATCH',
      body: { qty, expectedEditVersion },
    }
  );

  return response;
};
